import axios from 'axios';
import useSWR from 'swr';
import Cookies from 'js-cookie';

import { getApiUrl, getDomain, formatAndThrowApiError } from '@/helpers/api';

export const useSelf = () => {
  const urlStr = `${getApiUrl()}/self`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePutSelf = () => {
  const putTenant = async (payload) => {
    try {
      const url = `${getApiUrl()}/self`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putTenant;
};

export const useChangePassword = () => {
  const changePassword = async (payload) => {
    try {
      const url = `${getApiUrl()}/self/change-password`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return changePassword;
};

export const useUserByActivationId = (activationId) => {
  const urlStr = `${getApiUrl()}/user/activation/${activationId}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useActivateUser = () => {
  const putTenant = async (activationId, payload) => {
    try {
      const url = `${getApiUrl()}/user/activate/${activationId}`;
      const response = await axios.put(url, payload);
      Cookies.set(`token`, response.data.token, { domain: getDomain() });
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putTenant;
};
